export function getView(width) {
  let newView = "MobileView";
  if (width > 1000) {
    newView = "DesktopView";
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: "COLLPSE_CHANGE",
  COLLPSE_OPEN_DRAWER: "COLLPSE_OPEN_DRAWER",
  CHANGE_OPEN_KEYS: "CHANGE_OPEN_KEYS",
  TOGGLE_TOP_MENU: "TOGGLE_TOP_MENU",
  TOGGLE_ALL: "TOGGLE_ALL",
  CHANGE_CURRENT: "CHANGE_CURRENT",
  CLEAR_MENU: "CLEAR_MENU",
  SELECT_LAYOUT : "SELECT_LAYOUT",
  SET_LAYOUTS_KEY_NAMES : "SET_LAYOUTS_KEY_NAMES",
  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== "DesktopView";
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height
    };
  },
  toggleTopMenu: () => ({
    type: actions.TOGGLE_TOP_MENU
  }),
  toggleOpenDrawer: () => ({
    type: actions.COLLPSE_OPEN_DRAWER
  }),
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current
  }),
  clearMenu: () => ({ type: actions.CLEAR_MENU }),
  selectLayout : (layoutKeyName) => {
    return {
      type: actions.SELECT_LAYOUT,
      selectedLayout: layoutKeyName ,
    };
  },
  setLayoutsKeysNames:(layoutKeyNames)=>{
    return {
      type: actions.SET_LAYOUTS_KEY_NAMES,
      currentLayoutsKeysNames:layoutKeyNames
    };
  }
};
export default actions;
